import styled from 'styled-components';

const StyledGameTagGeneric = styled.div`
	font: var(--tag-generic-font);
	background-color: ${props => props.bgColor};
	color: ${props => props.textColor};
	font-size: var(--lc-card-font-size);
	line-height: var(--game-tag-line-height);
	text-transform: uppercase;
	font-weight: 700;
	letter-spacing: 0.1em;
	height: 16px;
	border-radius: 2px;
	padding: 0px 4px;
	display: inline-block;
	position: relative;
	top: -4px;
	left: -2px;
`;

const GameTagGeneric = ({ text, bgColor, textColor }) => (
	<StyledGameTagGeneric data-testid="tag-generic" bgColor={bgColor} textColor={textColor}>
		{text?.toUpperCase()}
	</StyledGameTagGeneric>
);

export default GameTagGeneric;
